import { render, staticRenderFns } from "./EditorJS.vue?vue&type=template&id=19769bf3"
import script from "./EditorJS.vue?vue&type=script&lang=js"
export * from "./EditorJS.vue?vue&type=script&lang=js"
import style0 from "./EditorJS.vue?vue&type=style&index=0&id=19769bf3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports